import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({
  selector: 'app-hide-button-cell',
  template: `
    <button mat-raised-button color="primary" style="line-height: 2" (click)="hideSelected()">Hide</button>
    <button mat-raised-button color="primary" style="line-height: 2" (click)="approveSelected()">Approve</button>
  `
})
export class QuarantineOperationButtonRendererComponent implements ICellRendererAngularComp {
    public params: any;

    constructor() {}

    agInit(params: any): void {
      this.params = params;
    }

    public hideSelected() {
      this.params.context.componentParent.hideSelected(this.params.data);
    }

    public approveSelected() {
      this.params.context.componentParent.approveSelected(this.params.data);
    }

    refresh(): boolean {
      return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/quarantine/quarantine-operation-cell.component.ts